import { configureStore } from '@reduxjs/toolkit'
import packages from './reducers/packagesSlice'
import bookings from './reducers/bookingsSlice'
import agencies from './reducers/agenciesSlice'
import profile from './reducers/adminProfileSlice'
import configurations from './reducers/configSlice'

import collapsed from './reducers/collpseSlice'
export const store = configureStore({
  reducer: {
    collapsed,
    packages,
    bookings,
    agencies,
    profile,
    configurations
  }
})